import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { sdk } from "@/api/sdk";
import { PortalPage } from "@/features/portal/components/portal-chrome";
import { DIRECTORY_DAYS } from "@/features/portal/modules/coaches/directory-days";
import { PortalHero } from "@/features/portal/modules/hero/portal-hero";
import { PortalWelcome } from "@/features/portal/modules/welcome/portal-welcome";
import { organizationJsonLd, pageMeta, websiteJsonLd } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/")({
  head: () => ({
    meta: pageMeta({ title: m.seo_home_title(), description: m.app_description() }),
    scripts: [organizationJsonLd(), websiteJsonLd()],
  }),
  component: PortalLanding,
  // The coaches and their open times are read before the page draws. A directory that cannot be
  // reached leaves the section out rather than failing the route: somebody who already has a
  // coach still needs everything else on the page.
  loader: async () => {
    const bookable = await sdk.t.bookable.$get.setQueryParams({ days: String(DIRECTORY_DAYS) }).send();
    return { crumb: m.landing_crumb(), trainers: bookable.data ?? [] };
  },
  // A sign-in that bounced off a private page lands here with where it was going.
  validateSearch: z.object({ redirect: z.string().optional() }),
});

/**
 * The front door of the app people train in. Their coach's own page is /<slug>; this one is
 * for somebody who has the app but not the link.
 */
function PortalLanding() {
  const { trainers } = Route.useLoaderData();

  return (
    <PortalPage head={<PortalHero />}>
      <PortalWelcome trainers={trainers} />
    </PortalPage>
  );
}
